import { useEffect, useState } from 'react'

import { QueryHookOptions } from '@apollo/client'

import {
  IGetSitePermitAggregationListQuery,
  IGetSitePermitAggregationListQueryVariables,
  useGetSitePermitAggregationListQuery,
  useListenToSitePermitByIdSubscription,
} from '~/client/graph/operations/generated/SitePermits.generated'
import Workflow from '~/client/src/shared/models/Workflow'

import { EMPTY_OBJECT_ID } from '../utils/GraphExecutor'

export default function useWorkflowById(
  projectId: string,
  workflowId: string,
  options?: QueryHookOptions<
    IGetSitePermitAggregationListQuery,
    IGetSitePermitAggregationListQueryVariables
  >,
) {
  if (!projectId || !workflowId) {
    return {
      workflow: null,
      workflowLoading: false,
    }
  }

  const [workflow, setWorkflow] = useState<Workflow>(null)

  const { data: workflowData, loading: workflowLoading } =
    useGetSitePermitAggregationListQuery({
      variables: {
        filter: {
          projectId,
          ids: [workflowId],
        },
        limit: 1,
        offset: 0,
      },
      skip: !projectId || !workflowId,
      fetchPolicy: 'cache-and-network',
      ...(options || {}),
    })

  useEffect(() => {
    const workflow = workflowData?.sitePermitsAggregation?.data?.[0]
    if (workflow) {
      setWorkflow(Workflow.fromDto(workflow))
    }
  }, [workflowData?.sitePermitsAggregation?.data])

  useListenToSitePermitByIdSubscription({
    variables: {
      id: workflowId,
    },
    onSubscriptionData: data => {
      const { sitePermit } = data.subscriptionData.data
      if (sitePermit?.id === EMPTY_OBJECT_ID) return

      setWorkflow(() => {
        if (!sitePermit?.item) return null
        return Workflow.fromDto(sitePermit.item)
      })
    },
  })

  return {
    workflow,
    workflowLoading,
  }
}
